const phoneNrs = [
    { value: 'home',      text: 'Home' },
    { value: 'work',      text: 'Work' },
    { value: 'mobile',    text: 'Mobile' },
    { value: 'other',     text: 'Other' }
  ];

export default phoneNrs;